import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { BaseUserResponseModel } from "app/based/baseApiModel/baseUserModel/BaseUserResponseModel";
import { isNull, isUndefined } from "lodash";
import { RoleResponseEntity } from "../RoleResponseEntity";
import { BasePermissionMenu } from "app/based/baseApiModel/basePermissionMenu/BasePermissionMenu";

export class DetailRoleEntity extends RoleResponseEntity {
  code?: string;
  createdAt?: string;
  level?: number;
  maximum?: string;
  name?: string;
  note?: string;
  order?: string;
  status?: number;
  type?: number;
  updatedAt?: string;
  users?: Array<BaseUserResponseModel>;
  features?: Array<BaseFilterListResponseModel>;
  menus?: Array<BasePermissionMenu>;

  constructor(data?: Partial<DetailRoleEntity>) {
    super();
    this.code = data?.code;
    this.createdAt = data?.createdAt;
    this.level = data?.level;
    this.maximum = data?.maximum;
    this.name = data?.name;
    this.note = data?.note;
    this.order = data?.order;
    this.status = data?.status;
    this.type = data?.type;
    this.updatedAt = data?.updatedAt;
    this.menus = data?.menus;
    this.users = this.removeNullVal(data?.users);
    this.features = data?.features;
  }

  public removeNullVal?(users?: Array<BaseUserResponseModel>) {
    return users?.filter((item) => !isUndefined(item) && !isNull(item));
  }
}
